<template>
  <div class="dialogbox">
    <div class="tip right" v-show="showPartyChild">
      <div style="display:flex;flex-direction:column">
        <!-- v-for="(item,index) in menu" -->
        <div v-for="(item, index) in menu" :key="index" class="body" @click="changeDataList(item)">
          <img :src="require('@/assets/image/dang2.png')"  class="oneImg" />
          <div class='titleFont'>
            {{item.meta.title}}
          </div>
        </div>
        <!-- <div class="body" style="margin-top:25px" @mouseover="changeActiveHover(0)" @mouseout="removeActive(1)" @click="changeDataList(2)">
          <img src="@/assets/image/xue2.png" class="twoImg" v-show="hoverValue == 1" />
          <img src="@/assets/image/xue1.png" class="twoImg" v-show="hoverValue != 1 && hoverValue !=3" />
          <div :class="[hoverValue == 1 ? 'titleFont' : 'titleFontHover']">
            学习习近平新时代中国特色社会主义思想专栏
          </div>
        </div>
        <div class="body" @click="changeDataList(4)">
          <img src="@/assets/image/dang1.png" class="oneImg" v-show="chooseLanValue != 2" />
          <img src="@/assets/image/dang2.png" class="oneImg" v-show="chooseLanValue == 2" />
          <div :class="[chooseValue == 2 ? 'titleFont' : 'titleFontHover']">
            双拥专栏
          </div>
        </div> -->
      </div>
    </div>
  </div>
  <!-- <div class="tip top">top</div>
    <div class="tip bottom">bottom</div>
    <div class="tip left">left</div> -->
</template>

<script>
import { getsMenuList } from "@/api/common";
export default {
  name: "DialogBox",
  components: {},
  props: ["showParty"],
  data() {
    return {
      chooseValue: 1,
      chooseLanValue: 3,
      hoverLanValue: 2,
      hoverValue: 1,
      faValue: 1,
      showPartyChild: false,
      menu: []
    };
  },
  watch: {
    showParty(newName, oldName) {
      this.showPartyChild = newName;
    }
  },
  destroyed() { },
  mounted() {
    // this.showPartyChild = this.showParty;
    this.chooseValue = 1;
    this.hoverValue = 1;
    this.faValue = 1;
    this.loadData()
  },
  methods: {
    loadData(){
      let param = {
        name: 'party'
      }
      getsMenuList(param).then(res=>{
        if (res.code === 200) {
          this.menu = res.data
        }
      })
    },
    // 子组件离开
    remove() {
      console.log("离开");
      this.$emit("mouseOut");
    },
    //切换标签
    changeDataList(item) {
      let name = "TabParty";
      this.$store.commit("setTabPage", item.name);
      this.$emit("specialtyListFunction", item.id);
    },
    changeActiveLanHover() {
      this.chooseLanValue = 2
      this.chooseValue = 3
      this.hoverValue = 3
    }
  }
};
</script>

<style scoped>
.dialogbox {
  position: absolute;
  z-index: 11;
  top: -1.8518vh;
  right: 4.583vw;
}
.dialogbox .body {
  margin-left: 1.0416vw;
  margin-top: 1.944vh;
}
.dialogbox .body:hover .oneImg {
  filter: grayscale(0%);
}

.dialogbox .oneImg {
  width: 1.1458vw;
  height: 1.6667vh;
  float: left;
  filter: grayscale(100%);
}
.dialogbox .twoImg {
  width: 1.0416vw;
  height: 1.851vh;
  float: left;
}
.dialogbox .titleFont {
  font-size: 1.296vh;
  font-weight: 400;
  color: #333333;
  font-family: "Microsoft YaHei";
  margin-left: 0.46875vw;
  float: left;
  line-height: 1.111111vh;
  margin-top: 0.2777vh;
}
.dialogbox .titleFont:hover {
  color: #0f7d72;
}
.dialogbox .titleFontHover {
  font-size: 1.296vh;
  font-weight: 400;
  color: #0f7d72;
  font-family: "Microsoft YaHei";
  margin-left: 0.46875vw;
  float: left;
  line-height: 1.111111vh;
  margin-top: 0.277vh;
}

.tip {
  position: relative;
  margin: 1.8518vh auto;
  color: white;
  text-align: center;
  border-radius: 10px;
  font-family: sans-serif;
  width: 18.489vw;
  padding-bottom: 1.944vh;
  /* height: 14.37vh; */
  background: #ffffff;
  box-shadow: 0px 2px 7px 0px rgba(7, 49, 45, 0.63);
  border-radius: 6px;
}
.tip:after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  border: 0.7407vh solid;
}
.top:after {
  border-bottom-color: deepskyblue;
  left: 50%;
  bottom: 100%;
  margin-left: -0.78125vw;
}
.right:after {
  border-left-color: #ffffff;
  border-right-color: rgba(255, 255, 255, 0);
  border-top-color: rgba(255, 255, 255, 0);
  border-bottom-color: rgba(255, 255, 255, 0);
  left: 100%;
  top: 50%;
  margin-top: -0.3645vw;
}
.bottom:after {
  border-top-color: deepskyblue;
  top: 100%;
  left: 50%;
  margin-left: -0.78125vw;
}
.left:after {
  border-right-color: deepskyblue;
  top: 50%;
  right: 100%;
  margin-top: -0.46875vw;
}
</style>



// WEBPACK FOOTER //
// src/components/common/arrowDialogBoxA.vue